// extracted by mini-css-extract-plugin
export default {"inheritAddress":"AddressField_inheritAddress__lPliD","autoFilledAddressAlert":"AddressField_autoFilledAddressAlert__ZY-CC","autoFill":"AddressField_autoFill__NFrn2"};